import React, { useState, useEffect } from "react";
import {
	Divider,
	Card,
	CardHeader,
	CardContent,
	CardActions,
	Button,
	TextField,
	Grid,
	IconButton,
	Typography,
	Container,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { uploadEvent } from "api";
import { Delete, SendOutlined } from "@material-ui/icons";
import { useLocation, useHistory } from "react-router-dom";
import { validateEmail } from "utilities";
import FileUpload from "components/FileUpload";
function useQuery() {
	return new URLSearchParams(useLocation().search);
}
const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	textField: {
		minWidth: "35ch",
		margin: theme.spacing(1),
	},
	divider: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
}));
const positionMap = new Map([
	["undergrad", "Undergraduate"],
	[("graduate", "Graduate (Masters/PhD)")],
	["associate", "PostDoc/Research Assoc."],
]);
const EventUpload = (props) => {
	const classes = useStyles();
	const [form, setForm] = useState({});
	// let query = useQuery();
	let { search: query } = useLocation();
	let history = useHistory();
	const [links, setLinks] = useState([{ text: "", href: "" }]);

	const [status, setStatus] = useState({
		isLoading: false,
		isSuccess: false,
		isError: false,
	});

	const [uploads, setUploads] = useState();

	function handleSelectedFiles(files) {
		setUploads(files);
	}
	useEffect(() => {
		let q = new URLSearchParams(query);
		if (!q.has("position")) {
			setForm({ ...form, position: "undergrad" });
		} else {
			setForm({ ...form, position: q.get("position") });
		}
	}, [query]);
	const handleLinkChange = (key) => (event) => {
		console.log(key, event);
	};

	function handleChange(event) {
		const target = event.target;

		console.log(event);
		const value = target.checked ? target.checked : target.value;
		const name = target.name;
		setForm({
			...form,
			[name]: value,
		});
	}
	function handleSubmit(event) {
		event.preventDefault();
		console.log(form);
		const data = new FormData();
		data.append("resume", uploads?.current.files[0]);
		Object.entries(form).forEach(([key, value]) => data.append(key, value));
		setStatus({ isLoading: true });
		uploadEvent(data).then((res) => {
			console.log(res);
			if (res?.success) {
				setStatus({ isLoading: false, isSuccess: true });
			} else if (res?.error) {
				setStatus({ isLoading: false, isError: true });
			}
		});
		// alert(`Selected file - ${upload.current.files[0].name}`);
	}

	return (
		<Container maxWidth="lg">
			<Card style={{ marginTop: 16 }}>
				<CardHeader title="Submit an new Event/News"></CardHeader>
				<CardContent>
					<div>
						<TextField
							className={classes.textField}
							onChange={handleChange}
							name="title"
							id="standard-full-width"
							label="Title"
							fullWidth
							margin="normal"
							InputLabelProps={{
								shrink: true,
							}}
							variant="filled"
						/>
						<TextField
							className={classes.textField}
							onChange={handleChange}
							name="text"
							id="standard-full-width"
							label="Main News Text"
							multiline
							rows={8}
							fullWidth
							margin="normal"
							InputLabelProps={{
								shrink: true,
							}}
							variant="filled"
							helperText={`* ${
								2000 - (form?.text?.length ?? 0)
							} characters remaining`}
						/>
						<TextField
							className={classes.textField}
							onChange={handleChange}
							name="date"
							id="standard-full-width"
							label="Date"
							margin="normal"
							InputProps={{
								type: "date",
							}}
							InputLabelProps={{
								shrink: true,
							}}
							variant="filled"
						/>
						<Divider className={classes.divider} />
						<Typography variant="h5">
							Links <small style={{ fontSize: 12 }}>*optional</small>
						</Typography>

						{links.map((link, i) => {
							return (
								<div
									key={`link:${i}`}
									style={{
										display: "flex",
										flexDirection: "row",
										alignContent: "center",
									}}
								>
									<TextField
										className={classes.textField}
										onChange={handleLinkChange(i)}
										name="href"
										id="standard-full-width"
										label="URL"
										margin="normal"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
									/>

									<TextField
										className={classes.textField}
										onChange={handleLinkChange(i)}
										name="text"
										id="standard-full-width"
										label="Text"
										margin="normal"
										InputLabelProps={{
											shrink: true,
										}}
										variant="filled"
									/>
									<IconButton
										onClick={() => {
											let arr = links.filter((a, x) => x !== i);
											setLinks(arr);
										}}
									>
										<Delete />
									</IconButton>
								</div>
							);
						})}
						<br></br>
						<Button
							onClick={() => setLinks([...links, { text: "", href: "" }])}
						>
							Add Another Link
						</Button>
						<Divider className={classes.divider} />
						<Typography variant="h5">
							Image <small style={{ fontSize: 12 }}>*optional</small>
						</Typography>
						<Grid container direction="row" spacing={1}>
							<Grid xs={12} sm={12} md={6}>
								<TextField
									className={classes.textField}
									onChange={handleChange}
									name="source"
									id="standard-full-width"
									label="Image Source"
									margin="normal"
									InputLabelProps={{
										shrink: true,
									}}
									variant="filled"
								/>
							</Grid>
							<Grid xs={12} sm={12} md={6}>
								<FileUpload
									preview="table"
									files={uploads}
									onUpload={(f) => handleSelectedFiles(f)}
									inputProps={{
										accept: "image/*",
									}}
								/>
							</Grid>
						</Grid>
					</div>
				</CardContent>
				<CardActions style={{ display: "flex", justifyContent: "flex-end" }}>
					<Button
						variant="contained"
						disableElevation
						color="primary"
						startIcon={<SendOutlined />}
						onClick={handleSubmit}
					>
						Submit
					</Button>
				</CardActions>
			</Card>
		</Container>
	);
};

export default EventUpload;
